// Identificador estable de esta ventana/pestaña de Focus.
// Vive en sessionStorage: sobrevive al refresh, es único por pestaña.
const KEY = 'focus:sessionId'

export function getFocusSessionId(): string {
  let id = sessionStorage.getItem(KEY)
  if (!id) {
    id = crypto.randomUUID()
    sessionStorage.setItem(KEY, id)
  }
  return id
}

// Borra la identidad de la pestaña. Tras un logout forzado (expulsión), el próximo
// getFocusSessionId() genera una identidad nueva, de modo que un re-login en la misma
// pestaña cuente como sesión nueva y no reutilice la sesión vieja recién expulsada.
export function clearFocusSessionId(): void {
  sessionStorage.removeItem(KEY)
}
